import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import useBuildUpdateFlinksRows from './buildUpdateFlinksRows.helper';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateFlinksProps = {
  onSubmit: (params: vp.SetFlinksCredentialsRequest) => void;
  onBack: () => void;
  defaultValues: vp.SetFlinksCredentialsRequest;
};
type FC = FunctionComponent<UpdateFlinksProps>;

const UpdateFlinksReview: FC = (props: UpdateFlinksProps) => {
  const { onSubmit, defaultValues, onBack } = props;
  const updateFlinksRows = useBuildUpdateFlinksRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Flinks.Update.Review' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ values, handleSubmit }) => {
        const updateFlinksTable: vp.TableProps = {
          name: 'update-flinks-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateFlinksRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={values[id]}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="lg" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title={t('pageTitle')} />
            </Box>
            <Table {...updateFlinksTable} />
            <Box width="100%" jc="fe" mt="md">
              <Button id="flinks-submit" type="submit" label={tGlobal('Buttons.save')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateFlinksReview;
